import _ from 'underscore';

import {ACTIONS} from './constants';
import {AttributeValues} from '../../types';

export type State = {
	loading: boolean;
	overflownX: boolean;
	overflownY: boolean;
	saving: boolean;
	storedData: AttributeValues | null;
};

export type Action =
	| {type: typeof ACTIONS.CLEAR_STORED_DATA}
	| {type: typeof ACTIONS.RESET}
	| {type: typeof ACTIONS.SET_LOADING; loading: boolean}
	| {type: typeof ACTIONS.SET_OVERFLOW_X; overflown: boolean}
	| {type: typeof ACTIONS.SET_OVERFLOW_Y; overflown: boolean}
	| {type: typeof ACTIONS.SET_SAVING; saving: boolean}
	| {type: typeof ACTIONS.SET_STORED_DATA; data: AttributeValues};

export const initialState: State = {
	loading: false,
	overflownX: false,
	overflownY: false,
	saving: false,
	storedData: null,
};

const reducer = (state: State, action: Action) => {
	switch (action.type) {
		case ACTIONS.CLEAR_STORED_DATA: {
			return {
				...state,
				storedData: null,
			};
		}
		case ACTIONS.RESET: {
			return initialState;
		}
		case ACTIONS.SET_LOADING: {
			return {
				...state,
				loading: action.loading,
			};
		}
		case ACTIONS.SET_OVERFLOW_X: {
			return {
				...state,
				overflownX: action.overflown,
			};
		}
		case ACTIONS.SET_OVERFLOW_Y: {
			return {
				...state,
				overflownY: action.overflown,
			};
		}
		case ACTIONS.SET_SAVING: {
			return {
				...state,
				saving: action.saving,
			};
		}
		case ACTIONS.SET_STORED_DATA: {
			return {
				...state,
				storedData: action.data,
			};
		}
	}
};

export default reducer;
